import { render, staticRenderFns } from "./CandidateProfileEnhanced.vue?vue&type=template&id=8966a7ce&"
import script from "./CandidateProfileEnhanced.vue?vue&type=script&lang=js&"
export * from "./CandidateProfileEnhanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports